import { Loader2 } from 'lucide-react';

import {
  formatTemplateRunStatus,
  resolveTemplateRunStatusTone,
  type TemplateRunStatusTone,
} from '@/lib/templateRunStatus';
import { cn } from '@/lib/utils';

const STATUS_TONE_CLASS_NAMES: Record<TemplateRunStatusTone, string> = {
  progress: 'border-amber-200 bg-amber-50 text-amber-800',
  success: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  warning: 'border-amber-200 bg-amber-50 text-amber-800',
  error: 'border-rose-200 bg-rose-50 text-rose-700',
  neutral: 'border-[color:var(--site-border-soft)] bg-[var(--site-surface-strong)] text-[var(--site-ink)]',
};

export function TemplateRunStatusBadge({ status, className }: { status: string; className?: string }) {
  const tone = resolveTemplateRunStatusTone(status);
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded border px-2 py-0.5 text-xs font-medium',
        STATUS_TONE_CLASS_NAMES[tone],
        className,
      )}
    >
      {tone === 'progress' ? <Loader2 className="h-3 w-3 animate-spin" aria-hidden="true" /> : null}
      {formatTemplateRunStatus(status)}
    </span>
  );
}

// Takes every backend text that describes the failure; blank and repeated ones are dropped.
export function TemplateRunTechnicalDetails({ messages }: { messages: Array<string | null | undefined> }) {
  const lines = Array.from(
    new Set(messages.map((message) => message?.trim()).filter((message): message is string => Boolean(message))),
  );
  if (lines.length === 0) {
    return null;
  }
  return (
    <details className="mt-2">
      <summary className="cursor-pointer select-none">Технические подробности</summary>
      <div className="mt-1 whitespace-pre-wrap font-mono text-[11px] [overflow-wrap:anywhere]">{lines.join('\n')}</div>
    </details>
  );
}
